export default __webpack_public_path__ + "static/media/character7.94cc96d9.png";